export const DMS_OAUTH_FLOW_COOKIE_NAME = 'dms_oauth_flow';
